/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
/* NOTE: THIS COMPONENT IS STILL A WORK IN PROGRESS */
import React, { forwardRef } from "react"
import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ForwardedRef, ReactNode } from "react"
import clsx from "clsx"
import { cva, VariantProps } from "cva"

import styles from "./link.module.css"

export type LinkVariantProps = VariantProps<typeof linkVariant>

type LinkAsLink = LinkVariantProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkVariantProps> & {
    as?: "link"
    className?: string
    children?: ReactNode
  }

type LinkAsButton = LinkVariantProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, keyof LinkVariantProps> & {
    as: "button"
    className?: string
    children?: ReactNode
  }

type LinkProps = LinkAsLink | LinkAsButton

const linkVariant = cva({
  base: styles.base,
  variants: {
    variant: {
      primary: styles.primary,
    },
    size: {
      xsmall: styles.xsmall,
      xxsmall: styles.xxsmall,
      small: styles.small,
      medium: styles.medium,
    },
    theme: {
      dark: styles.dark,
      light: styles.light,
    },
    icon: {
      arrowRight: styles.arrowRightIcon,
      arrowLeft: styles.arrowLeftIcon,
      reset: styles.resetIcon,
      list: styles.listIcon,
      grid: styles.gridIcon,
      downArrow: styles.downArrowIcon,
      download: styles.downloadIcon,
      external: styles.externalIcon,
      plus: styles.plusIcon,
      x: styles.xIcon,
      chevronLeft: styles.chevronLeftIcon,
      chevronRight: styles.chevronRightIcon,
    },
    override: {
      iconOnly: styles.iconOnly,
      noDefaultUnderline: styles.noDefaultUnderline,
    },
  },
  compoundVariants: [
    {
      theme: "dark",
      icon: "arrowRight",
      className: styles.darkArrowRightIcon,
    },
    {
      theme: "dark",
      icon: "arrowLeft",
      className: styles.darkArrowLeftIcon,
    },
    {
      theme: "dark",
      icon: "reset",
      className: styles.darkResetIcon,
    },
    {
      theme: "dark",
      icon: "list",
      className: styles.darkListIcon,
    },
    {
      theme: "dark",
      icon: "grid",
      className: styles.darkGridIcon,
    },
    {
      theme: "dark",
      icon: "downArrow",
      className: styles.darkDownArrowIcon,
    },
    {
      theme: "dark",
      icon: "download",
      className: styles.darkDownloadIcon,
    },
    {
      theme: "dark",
      icon: "external",
      className: styles.darkExternalIcon,
    },
    {
      theme: "dark",
      icon: "plus",
      className: styles.darkPlusIcon,
    },
    {
      theme: "dark",
      icon: "x",
      className: styles.darkXIcon,
    },
    {
      theme: "dark",
      icon: "chevronLeft",
      className: styles.darkChevronLeftIcon,
    },
    {
      theme: "light",
      icon: "arrowRight",
      className: styles.lightArrowRightIcon,
    },
    {
      theme: "light",
      icon: "arrowLeft",
      className: styles.lightArrowLeftIcon,
    },
    {
      theme: "light",
      icon: "reset",
      className: styles.lightResetIcon,
    },
    {
      theme: "light",
      icon: "list",
      className: styles.lightListIcon,
    },
    {
      theme: "light",
      icon: "grid",
      className: styles.lightGridIcon,
    },
    {
      theme: "light",
      icon: "downArrow",
      className: styles.lightDownArrowIcon,
    },
    {
      theme: "light",
      icon: "download",
      className: styles.lightDownloadIcon,
    },
    {
      theme: "light",
      icon: "external",
      className: styles.lightExternalIcon,
    },
    {
      theme: "light",
      icon: "plus",
      className: styles.lightPlusIcon,
    },
    {
      theme: "light",
      icon: "x",
      className: styles.lightXIcon,
    },
    {
      theme: "light",
      icon: "chevronLeft",
      className: styles.lightChevronLeftIcon,
    },
    {
      theme: "light",
      icon: "chevronRight",
      className: styles.chevronRightIcon,
    },
    {
      theme: "dark",
      icon: "chevronRight",
      className: styles.darkChevronRightIcon,
    },
  ],
  defaultVariants: {
    variant: "primary",
    size: "medium",
    theme: "light",
  },
})

export const Link = forwardRef<HTMLButtonElement | HTMLAnchorElement, LinkProps>(
  ({ className, variant, size, theme, icon, override, ...props }, ref) => {
    // button element
    if (props?.as === "button") {
      const { children, ...rest } = props
      return (
        <button
          className={clsx(linkVariant({ variant, size, theme, icon, override, className }))}
          ref={ref as ForwardedRef<HTMLButtonElement>}
          {...rest}
        >
          <span>{children}</span>
        </button>
      )
    }

    // default link element
    const { children, ...rest } = props
    return (
      <a
        className={clsx(linkVariant({ variant, size, theme, icon, override, className }))}
        ref={ref as ForwardedRef<HTMLAnchorElement>}
        {...rest}
      >
        <span>{children}</span>
      </a>
    )
  },
)
Link.displayName = "Link"
